
export default function TextIDont(){
    return(
        <div className="flex items-center pb-c2 justify-start">
        I don’t want to receive marketing messages from Airbnb.
      </div>
    )
}